export default "__VITE_ASSET__DdVBdPqr__"